var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.01318,
    y: 0.891181,
    width: 10.6482,
    height: 10.6482,
    rx: 2.99481,
    transform: "rotate(45 8.01318 0.891181)",
    fill: "url(#paint0_linear_1_7768)",
    stroke: "url(#paint1_linear_1_7768)",
    strokeWidth: 0.665512
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49921 11.0678C7.15038 11.0678 6.84031 11.0081 6.569 10.8886C6.29931 10.7691 6.08614 10.6027 5.92949 10.3896C5.77284 10.1764 5.68967 9.9301 5.67998 9.65072H6.59081C6.59888 9.78476 6.64329 9.90184 6.72404 10.002C6.80479 10.1005 6.91218 10.1772 7.04622 10.2321C7.18026 10.287 7.33045 10.3145 7.49679 10.3145C7.67443 10.3145 7.83189 10.2838 7.96916 10.2224C8.10643 10.1594 8.21382 10.0722 8.29134 9.96079C8.36885 9.84936 8.4068 9.72097 8.40519 9.57562C8.4068 9.42544 8.36805 9.29301 8.28891 9.17835C8.20978 9.06369 8.09512 8.97406 7.94493 8.90946C7.79636 8.84486 7.6171 8.81257 7.40716 8.81257H6.9687V8.11976H7.40716C7.57996 8.11976 7.73095 8.08988 7.86015 8.03013C7.99096 7.97038 8.09351 7.8864 8.16779 7.7782C8.24208 7.66838 8.27842 7.54161 8.2768 7.39788C8.27842 7.25738 8.24693 7.13545 8.18233 7.0321C8.11935 6.92713 8.02972 6.84557 7.91344 6.78743C7.79878 6.7293 7.66393 6.70023 7.5089 6.70023C7.35709 6.70023 7.21659 6.72768 7.0874 6.78259C6.9582 6.8375 6.85404 6.91582 6.77491 7.01756C6.69578 7.11769 6.65379 7.23719 6.64894 7.37608H5.78414C5.7906 7.09831 5.87054 6.85445 6.02396 6.64451C6.179 6.43295 6.38571 6.26823 6.6441 6.15034C6.90249 6.03083 7.19237 5.97108 7.51374 5.97108C7.84481 5.97108 8.13226 6.03326 8.37612 6.15761C8.62159 6.28034 8.81135 6.44587 8.94539 6.6542C9.07943 6.86253 9.14645 7.09266 9.14645 7.34459C9.14806 7.62397 9.0657 7.85814 8.89936 8.04709C8.73464 8.23603 8.51824 8.35958 8.25016 8.41771V8.45647C8.59898 8.50492 8.86625 8.63412 9.05197 8.84406C9.23931 9.05238 9.33216 9.31158 9.33055 9.62165C9.33055 9.89942 9.25142 10.1481 9.09315 10.3678C8.9365 10.5858 8.7201 10.757 8.44395 10.8813C8.16941 11.0057 7.8545 11.0678 7.49921 11.0678Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_7768",
    x1: 19.4683,
    y1: 11.7343,
    x2: 5.83183,
    y2: 7.98992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_7768",
    x1: 19.4683,
    y1: 11.7343,
    x2: 5.83183,
    y2: 7.98992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A52FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree);
export default __webpack_public_path__ + "static/media/three.0ddf49870c7f550a02f63756600a39fd.svg";
export { ForwardRef as ReactComponent };